import { RequestQueryBuilder } from '@nestjsx/crud-request';
import { applicationApi } from '../../common/api';
import { BasicKeyValue, GeneralConfig, GeneralInfo, GeneralInfoByTypeWrapper, GeneralReportData, LksbGoodMetricCriteriaMap } from './types';

// Define a service using a base URL and expected endpoints
export const generalInfoApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeneralInfoByServiceType: builder.query<GeneralInfoByTypeWrapper, string>({
      query: (query) => `general-infos/service-type/${query}`,
      providesTags: [{ type: 'GeneralInfos', id: 'LIST' }],
    }),
    getGeneralInfoByType: builder.query<GeneralInfo[], string>({
      query: (type) =>
        'general-infos?' +
        RequestQueryBuilder.create()
          .setFilter({
            field: 'type',
            operator: '$eq',
            value: type,
          })
          .query(),
      providesTags: [{ type: 'GeneralInfos', id: 'LIST' }],
    }),
    getGeneralInfo: builder.query<GeneralInfo, string>({
      query: (query) => `general-infos/${query}`,
    }),
    createGeneralInfo: builder.mutation<GeneralInfo, any>({
      query: (body) => ({
        url: 'general-infos',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'GeneralInfos', id: 'LIST' }],
    }),
    deleteGeneralInfo: builder.mutation<any, number>({
      query: (id) => ({
        url: `general-infos/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'GeneralInfos', id: 'LIST' }],
    }),
    updateGeneralInfo: builder.mutation<GeneralInfo, any>({
      query: (body) => ({
        url: 'general-infos',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'GeneralInfos', id: 'LIST' }],
    }),
    getGeneralConfig: builder.query<GeneralConfig, string>({
      query: (query) => `config/getByKey/${query}`,
    }),
    getGeneralDataConfig: builder.query<GeneralReportData[] | GeneralReportData | null, string>({
      query: (query) => `config/getByKey/${query}`,
    }),
    getLksbGoodMetricCriteriaConfig: builder.query<LksbGoodMetricCriteriaMap | null, string>({
      query: (query) => `config/getByKey/${query}`,
    }),
    upsertGeneralConfig: builder.mutation<BasicKeyValue, any>({
      query: (body) => ({
        url: 'config',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'GeneralConfig', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetGeneralInfoByServiceTypeQuery,
  useGetGeneralInfoByTypeQuery,
  useGetGeneralInfoQuery,
  useCreateGeneralInfoMutation,
  useDeleteGeneralInfoMutation,
  useUpdateGeneralInfoMutation,
  useGetGeneralConfigQuery,
  useGetGeneralDataConfigQuery,
  useGetLksbGoodMetricCriteriaConfigQuery,
  useUpsertGeneralConfigMutation,
} = generalInfoApi;
